
<template>
  <div style="position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.4); width: 100%; height: 100%; z-index: 999;" @click="closeView">
    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 500px; height: 90%; background: white;" @click.stop="dummy">
      <div style="width: 100%; height: 50px;">
        <table style="width: 100%;">
          <tr>
            <td>Search</td>
            <td><input v-model="word" @keyup="search" class="form-control"></input></td>
            <td @click="word = ''">Clear</td>
            <td @click="closeView">Close</td>
          </tr>
        </table>

      </div>
      <div style="width: 100%; height: calc(100% - 50px);">
        <div class="container">
          <div class="row">
            <div v-for="item in items" :key="'item-result-' + item.id" @click="selectItem(item)">
              {{item.title}} {{item.address1}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {searchOrganisations} from "../api/agents";

export default {
  name:'AgentSelectorView',
  data(){
    return {
      word:'',
      items:[],
    }
  },
  props: {
    onItemSelected: {
      type: Function,
      default: null,
    },
    onClose: {
      type: Function,
      default: null,
    },
    type: {
      type:String,
      default: function(){return null;},
    },
    request: {
      type: Object,
      default: function() {return null;}
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    dummy: function() {

    },
    search: function() {
      if(this.$data.word.length < 3) {
        this.$data.items = [];
        return;
      }

      let self = this;
      let query = 'word=' + this.$data.word;
      console.log("search for " + this.$data.word + ' for type ' + this.request.type);

      searchOrganisations(this.request.type, query)
        .then(function(data) {
          console.log("result");
          console.log(data);
          if(data.success === true) {

            self.$data.items = data.item;
          } else {
            self.$data.items = [];
          }
        })
        .catch(function(err) {
          console.log(err);
        })

    },
    selectItem: function(item) {
      if(this.onItemSelected !== null) {
        this.onItemSelected(item);
      } else if(this.request !== null) {
        if(this.request.onItemSelected !== undefined) {
          this.request.onItemSelected(item);
        }
      }

      if(this.onClose !== null) {
        this.onClose();
      }
    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgentSelectorView.vue